import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Location } from '@angular/common';
import { ConfirmModal } from '@app/shared/modals';
import { AppFilter } from '@app/shared/models';
import { SuiModalService, ModalSize } from '@richardlt/ng2-semantic-ui';
import { AuditTrailDetailModal } from 'src/modules/features/admin/modals';
import { Subject, Subscription } from 'rxjs';
import { map, take, takeUntil } from 'rxjs/operators';
import { NavigationStart, Router, ActivatedRoute } from '@angular/router';

import { CompanyOwnershipService } from '@app/shared/services/company-ownership.service';
import { environment } from 'src/environments/environment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  LinkDocumentModal,
  NewCompanyModal,
  NewIndividualModal,
} from 'src/modules/features/contractor/modals';
import {
  AolService,
  CompanyService,
} from 'src/modules/features/contractor/services';
import { PdfViewerService } from 'src/modules/features/admin/services';
interface Document {
  documentTypeId: string;
  documentTypeName: string;
  isRequired: boolean;
  isActive: boolean;
  dateCreated: string;
  dateModified: string;
  group: any;
  createdBy: string;
  modifiedBy: string;
  uploadedFiles?: File[];
}
interface MyObjectType {
  countries: any[];
  shareHoldingAmount: number;
  item: string;
  affiliateTypeId: string;
  affiliateTypeName: string;
  usePercentage?: boolean;
  director: any;
}
interface UpdateCheck {
  message: string;
  isValid: boolean;
  currentValue?: string;
}
@Component({
  selector: 'app-company-update-mode',
  templateUrl: './update-mode.component.html',
  styleUrls: ['./update-mode.component.scss'],
})
export class DirectorsUpdateModeComponent implements OnInit {
  success: any;
  error: any;
  updateChecks: UpdateCheck[] = [
    {
      message: 'The percentage of shareholding shares must be 100%',
      isValid: this.isShareholdingValid(), // implement this method
      currentValue: '90%',
    },
    {
      message: 'All the required/mandatory documents must be uploaded/added',
      isValid: this.uploadSupportingFilesInvalid(),
    },
  ];

  private isShareholdingValid(): boolean {
    // Your validation logic here
    return false;
  }
  @Input() companyDirectors;
  @Input() countries;
  @Input() existing: boolean;
  @Input() documentsValid;
  @Input() documentss: Document[];
  @Input() savedPreviousStructure: any;
  @Input() usePercentage: boolean;
  @Input() shareholdingAmount: number;
  @Input() uploads;
  @Input() initialDirectorsStructure;
  @Input() allLinkedDocuments: any = [];
  @Input() uploadedDocuments: any = [];
  @Input() typeStructure!: string;
  @Output() updateDirector = new EventEmitter();
  @Output() LinkDocument = new EventEmitter();
  @Output() startAfresh = new EventEmitter();
  unsubscribe$: Subject<boolean> = new Subject();
  filter: AppFilter = new AppFilter();
  totalItems: number = 0;
  rows: number = 2;
  currentPage: number = 1;
  maxSize: number = 7;
  organizationId: string;
  companyType: Array<any> = [];
  baseUrl = environment.API_SERVER;
  ownershipType: Array<any> = [];
  isEdit: boolean = false;
  chatLink;
  companyShareholderForm: FormGroup;
  currentForm: FormGroup;
  changeRequestId;
  result = [];
  documents = [];
  searchFilter = {
    groupOp: 'OR',
    rules: [
      {
        field: 'firstName',
        op: 'cn',
        data: '',
      },
      {
        field: 'lastName',
        op: 'cn',
        data: '',
      },
    ],
  };
  optionFilter = {
    groupOp: 'OR',
    rules: [
      {
        field: 'optionType.optionTypeId',
        op: 'eq',
        data: 'individual_ownership_type',
      },
    ],
  };
  directorStatus: string;
  message;
  redirect_url;
  applicationType;
  affiliateTypeName!: string;
  affiliateTypeId!: string;
  companyTypeId = JSON.parse(window.localStorage.getItem('user')).organizationId
    .jpaContractor.companyType.optionId;
  allStatus: any;

  subject = new Subject<boolean>();
  personnelStructureKeys!: string[];
  structureObject: any;
  pendingArr: boolean[] = [];
  companyAffiliateTypes;
  allAffiliateTypes;
  allStructures = [];
  redirect_params: any;

  private eventSubscription: Subscription;
  constructor(
    private modalService: SuiModalService,
    private location: Location,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private companySvc: CompanyService,
    private aolService: AolService,
    private pdfViewerService: PdfViewerService
  ) {
    this.organizationId = window.localStorage.getItem('organizationId');
    this.activatedRoute.queryParams.subscribe((params) => {
      this.companyDirectors = [];
      this.affiliateTypeId = params.typeId;
      this.affiliateTypeName = params.typeName;
      this.filter.filters = JSON.stringify(this.searchFilter);
      // this.getDocumentUploaded();
      // this.getPage(1);
    });
  }

  checkIfStructureChanged() {
    const hasAddOrUpdate = this.companyDirectors.some(
      (item) => item.actionType === 'ADD' || item.actionType === 'UPDATE'
    );
    if (hasAddOrUpdate) {
      return false;
    }
    return (
      this.initialDirectorsStructure.length === this.companyDirectors.length
    );
  }
  checkDisabled() {
    if (this.affiliateTypeId === 'shareholder_type') {
      return !(
        this.returnTotalShareholding() >= 99 &&
        this.returnTotalShareholding() <= 100
      );
    } else {
      return false;
    }
  }

  returnTotalShareholding() {
    let totalShareholding = 0;
    if (this.companyDirectors.length > 0) {
      totalShareholding = this.companyDirectors.reduce(
        (sum, item) => sum + item.shareholding,
        0
      );
    }
    return totalShareholding;
  }
  uploadSupportingFilesInvalid(): boolean {
    // If no upload configuration exists, it's invalid
    if (!this.uploads) {
      return true;
    }

    // If uploads are required
    if (this.uploads.length > 0) {
      // Get required documents
      const requiredDocs = this.uploads.filter((doc) => doc.isRequired);

      // Check if all required documents are either uploaded or linked
      const allRequiredDocsPresent = requiredDocs.every((requiredDoc) => {
        // Check if document is uploaded
        const isUploaded = this.documentss?.some(
          (doc) =>
            doc.documentTypeId === requiredDoc.documentTypeId &&
            doc.uploadedFiles &&
            doc.uploadedFiles.length > 0
        );

        // Check if document is linked
        const isLinked = this.allLinkedDocuments?.some(
          (doc) =>
            doc.documentTypeId.documentTypeId === requiredDoc.documentTypeId
        );
        return isUploaded || isLinked;
      });

      // Return true if any required document is missing
      return !allRequiredDocsPresent;
    }

    return false;
  }
  getDocumentUploaded() {
    this.callStarted();
    this.aolService
      .getDocumentUpload({
        optionId: this.affiliateTypeId,
      })
      .subscribe(
        (res: any) => {
          this.callCompleted();
          this.uploads = res.filter((item) => item.isActive);
          console.log(this.uploads, 'this.uploads');
          this.documentss = this.uploads.map((doc) => ({
            ...doc,
            uploadedFiles: [],
          }));
          console.log(this.documentss, 'document');
        },
        (error) => {
          this.callCompleted();
          this.error = error.error;
        }
      );
  }

  getPage(page) {
    this.filter.page = page;
    this.callStarted();
    this.companySvc
      .getCompanyDirector({
        organizationId: this.organizationId,
        ownershipType: this.affiliateTypeId,
        params: this.filter,
      })
      .subscribe(
        (res: any) => {
          this.callCompleted();
          this.totalItems = +res.records;
          this.rows = this.filter.rows;
          this.companyDirectors = res['rows'];
        },
        (error) => {
          this.callCompleted();
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error
            ? error.error
            : error;
        }
      );
  }
  getColorForLabel(label: string): string {
    switch (label) {
      case 'ADD':
        return '#5FD3A4';
      case 'DELETE':
        return '#FB4037';
      case 'UPDATE':
        return '#2C6ECB';
      default:
        return '#E4E5E7';
    }
  }
  getColorTextForLabel(label: string): string {
    switch (label) {
      case 'NONE':
        return '#505050';
      case undefined:
        return '#505050';
      default:
        return '#FFFFFF';
    }
  }
  deleteIndividual(director, currentIndex) {
    console.log(currentIndex, 'index');
    this.modalService
      .open(
        new ConfirmModal(
          `Remove ${this.affiliateTypeName}`,
          `Are you sure you want to remove ${
            director?.firstName + ' ' + director?.lastName
          }?`,
          ModalSize.Mini,
          'Remove',
          'Cancel'
        )
      )
      .onApprove(() => {
        this.companyDirectors.splice(currentIndex, 1);
      });
  }
  edit(director, i) {
    if (director?.companyName && director?.companyRegNumber) {
      let obj: MyObjectType = {
        countries: this.countries,
        shareHoldingAmount: this.shareholdingAmount,
        item: this.typeStructure,
        affiliateTypeId: this.affiliateTypeId,
        affiliateTypeName: this.affiliateTypeName,
        director: {
          ...director,
          organizationOwnershipTypeId: this.affiliateTypeId,
          ownershipTypeName: this.affiliateTypeName,
        },
      };
      if (this.affiliateTypeId === 'shareholder_type') {
        obj = { ...obj, usePercentage: this.usePercentage };
      }
      this.modalService
        .open(
          new NewCompanyModal(
            'Edit Shareholder Record',
            obj,
            true,
            ModalSize.Mini
          )
        )
        .onApprove((payload: any) => {
          this.updateDirector.emit({ payload, index: i });
        })
        .onDeny(() => {});
    } else {
      let obj: MyObjectType = {
        countries: this.countries,
        shareHoldingAmount: this.shareholdingAmount,
        item: this.typeStructure,
        affiliateTypeId: this.affiliateTypeId,
        affiliateTypeName: this.affiliateTypeName,
        director: {
          ...director,
          organizationOwnershipTypeId: this.affiliateTypeId,
          ownershipTypeName: this.affiliateTypeName,
        },
      };
      if (this.affiliateTypeId === 'shareholder_type') {
        obj = { ...obj, usePercentage: this.usePercentage };
      }
      this.modalService
        .open(
          new NewIndividualModal(
            'Edit Individual Record',
            obj,
            true,
            ModalSize.Mini
          )
        )
        .onApprove((payload: any) => {
          this.updateDirector.emit({ payload, index: i });
        })
        .onDeny(() => {});
    }
  }
  ngOnInit() {
    console.log(this.companyDirectors, 'company');
  }
  onFileChanges(event: any, document: Document): void {
    console.log(document);
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      const uploadedFiles: File[] = Array.from(fileList);
      document.uploadedFiles = document.uploadedFiles || [];
      document.uploadedFiles = [...document.uploadedFiles, ...uploadedFiles];
    }
  }
  viewFiles(file): void {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      const blob = new Blob([e.target.result], { type: file.type });
      const url = window.URL.createObjectURL(blob);
      window.open(url, '_blank');
    };
    reader.readAsArrayBuffer(file); // Use readAsArrayBuffer for binary data
  }
  viewDocument(data: any) {
    this.pdfViewerService.viewPdf(data);
  }
  removeDocument(index: number): void {
    this.documentss.splice(index, 1);
  }

  removeFile(document: Document, fileIndex: number): void {
    if (document.uploadedFiles) {
      document.uploadedFiles.splice(fileIndex, 1);
    }
  }
  removeLinkedDocument(doc, index) {
    if (doc) {
      this.allLinkedDocuments.splice(index, 1);
    }
  }
  editLinkedDocument(doc, index, data) {
    this.modalService
      .open(
        new LinkDocumentModal(
          `Edit Selected existing documents from ${data} Document Type`,
          doc,
          data,
          this.uploads,
          ModalSize.Tiny
        )
      )
      .onApprove((documents: any) => {
        console.log(documents, 'doc');
        if (doc) {
          this.allLinkedDocuments[index] = documents[0];
        }
      })
      .onDeny(() => {});
  }
  editFile(event: any, document: Document, fileIndex: number): void {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      const newFile: File = fileList[0];

      // Replace the existing file at the specified index
      if (document.uploadedFiles && document.uploadedFiles[fileIndex]) {
        document.uploadedFiles[fileIndex] = newFile;
      }
    }
  }

  returnDocumentType(data, id, typeId) {
    const filtered = data.filter((item) => {
      if (item.documentTypeId.documentTypeName) {
        return item.documentTypeId.documentTypeName === id;
      } else {
        return item.documentTypeId.documentTypeId === typeId;
      }
    });
    return filtered;
  }

  callStarted() {
    this.pendingArr.push(true);
  }

  callCompleted() {
    this.pendingArr.pop();
  }
}
